export default class ReorderButton extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="reorder-btn-container" >
                <button type="button" data-value={this.props.favId} className="btn btn-danger reorder-btn">{this.props.reOrderButton}</button>
            </div>
        );
    }
}

